import { createContext } from 'react'

const CaseDetailsContext = createContext()

export default CaseDetailsContext